(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.wrapper = this.querySelector('.header-wrapper--transparent');
      this.announcementBar =
        document.querySelector('.announcement-bar-section') ||
        (this.header ? this.header.previousElementSibling : null);
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.transparentDesktopOnly = this.getAttribute('data-transparent-desktop-only') === 'true';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setTransparentOffset();

      this.desktopMedia = window.matchMedia('(min-width: 990px)');
      this.onViewportChange = () => {
        this.setHeaderHeight();
        this.setTransparentOffset();
      };
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.onViewportChange);
      this.desktopMedia.addEventListener('change', this.onViewportChange);

      this.onResize = this.setTransparentOffset.bind(this);
      window.addEventListener('resize', this.onResize);

      if (window.ResizeObserver && this.announcementBar?.matches('.announcement-bar-section')) {
        this.announcementBarObserver = new ResizeObserver(() => this.setTransparentOffset());
        this.announcementBarObserver.observe(this.announcementBar);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.onTransparentPointerEnter = this.handleTransparentPointerEnter.bind(this);
      this.onTransparentPointerLeave = this.handleTransparentPointerLeave.bind(this);
      this.onTransparentFocusIn = this.handleTransparentFocusIn.bind(this);
      this.onTransparentFocusOut = this.handleTransparentFocusOut.bind(this);
      this.onDetailsToggle = this.updateTransparentState.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.setupTransparentInteractions();
      this.updateTransparentState();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setTransparentOffset() {
      if (!this.wrapper || !this.header) return;

      const announcementHeight =
        this.announcementBar && this.announcementBar.matches('.announcement-bar-section')
          ? this.announcementBar.offsetHeight
          : 0;

      document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResize);
      window.matchMedia('(max-width: 990px)').removeEventListener('change', this.onViewportChange);
      this.desktopMedia.removeEventListener('change', this.onViewportChange);
      if (this.announcementBarObserver) this.announcementBarObserver.disconnect();
      this.teardownTransparentInteractions();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const hasTransparentWrapper = this.wrapper !== null;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.currentScrollTop = scrollTop;
        this.updateTransparentState();
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!hasTransparentWrapper && !this.preventHide) {
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!hasTransparentWrapper) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (!hasTransparentWrapper) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
      this.updateTransparentState();
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    setupTransparentInteractions() {
      if (!this.wrapper) return;
      this.wrapper.addEventListener('mouseenter', this.onTransparentPointerEnter);
      this.wrapper.addEventListener('mouseleave', this.onTransparentPointerLeave);
      this.wrapper.addEventListener('focusin', this.onTransparentFocusIn);
      this.wrapper.addEventListener('focusout', this.onTransparentFocusOut);
      this.disclosureNodes = this.header.querySelectorAll('details');
      this.disclosureNodes.forEach((node) => node.addEventListener('toggle', this.onDetailsToggle));
    }

    teardownTransparentInteractions() {
      if (!this.wrapper) return;
      this.wrapper.removeEventListener('mouseenter', this.onTransparentPointerEnter);
      this.wrapper.removeEventListener('mouseleave', this.onTransparentPointerLeave);
      this.wrapper.removeEventListener('focusin', this.onTransparentFocusIn);
      this.wrapper.removeEventListener('focusout', this.onTransparentFocusOut);
      if (this.disclosureNodes) {
        this.disclosureNodes.forEach((node) => node.removeEventListener('toggle', this.onDetailsToggle));
      }
    }

    handleTransparentPointerEnter() {
      this.isTransparentHovered = true;
      this.updateTransparentState();
    }

    handleTransparentPointerLeave() {
      this.isTransparentHovered = false;
      this.updateTransparentState();
    }

    handleTransparentFocusIn() {
      this.isTransparentFocused = true;
      this.updateTransparentState();
    }

    handleTransparentFocusOut() {
      requestAnimationFrame(() => {
        this.isTransparentFocused = this.wrapper.contains(document.activeElement);
        this.updateTransparentState();
      });
    }

    hasOpenHeaderDetails() {
      return this.header.querySelector('details[open]') !== null;
    }

    shouldShowTransparentState() {
      if (!this.wrapper) return false;
      if (this.transparentDesktopOnly && !this.desktopMedia.matches) return false;
      if (this.hasOpenHeaderDetails()) return false;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return false;
      if (this.isTransparentHovered || this.isTransparentFocused) return false;
      if (this.header.classList.contains('scrolled-past-header')) return false;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return scrollTop <= this.headerBounds.top + 2;
    }

    updateTransparentState() {
      if (!this.wrapper) return;
      const shouldBeTransparent = this.shouldShowTransparentState();
      this.wrapper.classList.toggle('is-transparent-solid', !shouldBeTransparent);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
